// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3aG_h","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3XyNq"};